import { render, staticRenderFns } from "./MediaReference.vue?vue&type=template&id=2cb3d0b2&"
import script from "./MediaReference.vue?vue&type=script&lang=js&"
export * from "./MediaReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports